/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Deep_P2Inputs */

const en_minifier_deep_p2 = /** @type {(inputs: Minifier_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here is a measurement on a 40 record array of user objects, the shape of a typical list endpoint response. Pretty printed with two space indentation it is 10,562 bytes. Minified it is 6,154 bytes, a 41.7 percent reduction, which is the number a minifier will proudly show you. After gzip, the pretty printed version is 668 bytes and the minified version is 599 bytes. The real saving on the wire is 10.3 percent, not 41.7 percent.`)
};

const ko_minifier_deep_p2 = /** @type {(inputs: Minifier_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전형적인 목록 엔드포인트 응답 형태인 40개 사용자 객체 배열로 측정한 결과입니다. 2칸 들여쓰기로 정렬하면 10,562바이트입니다. 압축하면 6,154바이트로 41.7퍼센트 감소하며, 압축기가 자랑스럽게 보여주는 숫자가 이것입니다. gzip을 적용하면 정렬 버전은 668바이트, 압축 버전은 599바이트입니다. 실제 전송량 절감은 41.7퍼센트가 아니라 10.3퍼센트입니다.`)
};

const ja_minifier_deep_p2 = /** @type {(inputs: Minifier_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`典型的な一覧エンドポイントのレスポンス形である 40 件のユーザーオブジェクト配列で測った結果です。2 スペースインデントで整形すると 10,562 バイト。圧縮すると 6,154 バイトで 41.7 パーセント減となり、圧縮ツールが誇らしげに見せる数字がこれです。gzip をかけると整形版は 668 バイト、圧縮版は 599 バイトです。実際の転送量の削減は 41.7 パーセントではなく 10.3 パーセントです。`)
};

/**
* | output |
* | --- |
* | "Here is a measurement on a 40 record array of user objects, the shape of a typical list endpoint response. Pretty printed with two space indentation it is 10..." |
*
* @param {Minifier_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_deep_p2 = /** @type {((inputs?: Minifier_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_deep_p2(inputs)
	if (locale === "ko") return ko_minifier_deep_p2(inputs)
	return ja_minifier_deep_p2(inputs)
});